import React from 'react'
import { Link } from 'react-router-dom'
import SectionNavPills from '../components/SectionNavPills'

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SectionNavPills />
      <div className="container mx-auto px-4 py-10 md:py-14">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <header className="mb-6 md:mb-8 text-center">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              Kontakt
            </h1>
            <p
              className="text-sm sm:text-base text-gray-600 leading-relaxed max-w-2xl mx-auto"
              data-testid="contact-subheadline"
            >
              Máte otázku, problém alebo nápad na zlepšenie? Napíšte nám.
            </p>
          </header>

          <div className="space-y-4 sm:space-y-5">
            {/* Support / feedback block */}
            <section
              className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6 sm:p-8"
              data-testid="contact-support-block"
            >
              <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">
                Podpora a spätná väzba
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-5">
                Pomôžeme s prístupom, platbou, testami alebo technickým problémom. Spätná väzba nám zároveň pomáha EduMisiu zlepšovať.
              </p>

              <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
                <Link
                  to="/feedback"
                  className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition"
                  data-testid="contact-open-form-button"
                >
                  Otvoriť kontaktný formulár
                </Link>
                <a
                  href="mailto:podpora@edumisia.sk"
                  className="inline-flex items-center justify-center text-sm sm:text-base text-blue-700 font-medium hover:text-blue-800 transition"
                  data-testid="contact-support-email"
                >
                  podpora@edumisia.sk
                </a>
              </div>

              <p className="text-xs sm:text-sm text-gray-500 mt-3">
                Odpovedáme zvyčajne do 24 hodín v pracovných dňoch.
              </p>
            </section>

            {/* Provider / legal info */}
            <section
              className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6 sm:p-8"
              data-testid="contact-provider-block"
            >
              <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3">
                Údaje o poskytovateľovi
              </h2>
              <div className="text-sm text-gray-700 space-y-1">
                <p className="font-medium text-gray-900">Mgr. Vladislava Pajerová</p>
                <p>IČO: 51360454</p>
                <p>Miesto podnikania: 97409 Banská Bystrica, Lipová 6459/4</p>
                <p>Vedený v Živnostenskom registri SR (Okresný úrad Banská Bystrica)</p>
                <p>Číslo živnostenského registra: 430-58126</p>
              </div>
            </section>
          </div>

          <div className="mt-8 text-center">
            <Link
              to="/"
              className="text-sm text-blue-600 hover:text-blue-700 font-medium"
            >
              ← Späť na hlavnú stránku
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
